import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function recipeSlider() {
  const relatedRecipes = document.querySelectorAll('[related-recipes]');

  if ( !relatedRecipes.length ) return;
  
  relatedRecipes.forEach(recipe => {
    const data = recipe.dataset;
    const url = data.url.replace('tags', data.tag);

    fetch(url)
      .then(response =>  {
        return response.text();
      })
      .then(html =>  {
        const temp = document.createElement('div');
        temp.classList.add('d-none');
        temp.innerHTML = html;

        const items = temp.querySelectorAll('.swiper-slide');

        items.forEach(item => {
          if (item.dataset.handle === data.handle) {
            item.remove();
          }
        });

        recipe.innerHTML = temp.innerHTML;

        const swiper = new Swiper('.recipe__swiper', {
          modules: [Navigation, Pagination],
          loop: false,
          slidesPerView: 2,
          spaceBetween: 20,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            init: () => {
            }
          },
          breakpoints: {
            512: {
              slidesPerView: 'auto',
            },
            778: {
              slidesPerView: 2
            },
            992: {
              slidesPerView: 3
            }
          }
        });
      })
      .catch(function(error) {
        console.error('Error fetching related recipes:', error);
      });
  })
}
